import React, { useState } from 'react';

const QuizAdminScoreBoardPage = () => {
  const [userList, setUserList] = useState("[]");
  const [selectedScore, setSelectedScore] = useState(100);
  const [selectedUserNameList, setSelectedUserNameList] = useState([]);

  const onKeyUpUserName = (e) => {
    if (e.keyCode === 13 && e.target.value) {
      const name = e.target.value;
      const _userList = JSON.parse(userList);

      if (!_userList.filter(v => v.name === name).length) {
        _userList.push({ name, score: 0 });
        setUserList(JSON.stringify(_userList));
      }

      e.target.value = "";
    }
  };

  const onClickUserName = (e) => {
    const { username } = e.target.dataset;
    const selected = selectedUserNameList.filter(v => v === username).length > 0;

    if (!selected) {
      const _selectedUserNameList = [].concat(selectedUserNameList);
      _selectedUserNameList.push(username);
      setSelectedUserNameList(_selectedUserNameList);
      return;
    }

    const _selectedUserNameList = selectedUserNameList.filter(v => v !== username);
    setSelectedUserNameList(_selectedUserNameList);
  };

  const onChangeScore = ({ score }) => {
    setSelectedScore(score);
  };

  const onClickCorrect = (e) => {
    e.preventDefault();
    const _userList = (JSON.parse(userList) || [])
      .map((user => {
        if (selectedUserNameList.includes(user.name))
          user.score += window.Number(selectedScore);
        return user;
      }));

    setUserList(JSON.stringify(_userList));
  };

  const onClickWrong = (e) => {
    e.preventDefault();
    const _userList = (JSON.parse(userList) || [])
      .map((user => {
        if (selectedUserNameList.includes(user.name))
          user.score -= window.Number(selectedScore);
        return user;
      }));

    setUserList(JSON.stringify(_userList));
  };

  const users = JSON.parse(userList);

  return (
    <div className={"container"}>
      <div style={{ marginTop: 10 }}>
        <span style={{ fontSize: 36 }}>이번 라운드 점수 : {selectedScore}점</span>
      </div>
      <div style={{ marginTop: 10 }}>
        <ScoreSelecBox onChange={onChangeScore} />
      </div>
      <div style={{ marginTop: 10 }}>
        <input className={"form-control"} onKeyUp={onKeyUpUserName} placeholder={"이름"} autoComplete={"off"}></input>
      </div>
      <hr />
      <div style={{ marginTop: 10 }}>
        <div className={"list-group"}>
          {users.map((item, idx) => (
            <div
              key={idx}
              className={`list-group-item list-group-item-action ${selectedUserNameList.includes(item.name) ? "active" : ""}`}
              data-username={item.name}
              onClick={onClickUserName}>{item.name} : {item.score}</div>
          ))}
        </div>
      </div>
      <hr />
      {selectedUserNameList.length > 0 && (
        <div style={{ marginTop: 10 }}>
          <button className={"btn btn-lg btn-primary"} style={{ width: "50%", fontSize: 24 }} onClick={onClickCorrect}>정답</button>
          <button className={"btn btn-lg btn-danger"} style={{ width: "50%", fontSize: 24 }} onClick={onClickWrong}>땡!</button>
        </div>
      )}
    </div>
  );
};

const ScoreSelecBox = (props) => {
  const scores = [];
  for (let i = 0; i < 10; i++) scores.push((i + 1) * 100);

  const onChangeScore = (e) => {
    props.onChange && props.onChange({ score: e.target.value });
  };

  return (
    <select className={"custom-select"} onChange={onChangeScore}>
      {scores.map(v => (<option key={v} value={v}>{v}점</option>))}
    </select>
  );
};

export { QuizAdminScoreBoardPage };
